import { MAX_GRID_WIDTH } from "config/styleConsts";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { ChakraFlex as Flex, ChakraBox as Box } from "@airhelp/react-ui-components";
import { SectionHeader } from "modules/common/components/SectionHeader";
import { TeamCards } from "components";
import { textStyles, background } from "./OurTeam.styles";
import type { OurTeamProps } from "./OurTeam.d";

export const OurTeam = ({ subHeading, title, subtitle, cards }: OurTeamProps) => (
  <Box {...background}>
    <Flex
      flexDir="column"
      align={{ base: "flex-start", md: "center" }}
      px={{ base: 0, md: 8 }}
      pb={{ base: 6, md: 16 }}
      pt={{ base: 4, lg: 8 }}
      maxW={MAX_GRID_WIDTH}
      mx="auto"
    >
      <SectionHeader
        dataTestId="friend-header"
        header={title}
        preheader={subHeading}
        spacing={{ base: 4, lg: 6 }}
        alignItems={{ base: "flex-start", md: "center" }}
        mb={{ base: 4, lg: 6 }}
        mt={8}
        px={{ base: 4 }}
      />
      <RichtextAdapter content={subtitle} customStyles={textStyles} />
      <TeamCards cards={cards} />
    </Flex>
  </Box>
);
